import { AUTOMATED_TESTING_DATA_TEST_ID } from '@ga/constants/automated-testing'

export default defineNuxtPlugin(({ $gaApp }) => {
  const isAutomatedTesting =
    Boolean($gaApp.automatedTestingConfig?.[AUTOMATED_TESTING_DATA_TEST_ID]) ||
    $gaApp.config.get('devConfig')

  return {
    provide: {
      getDataTestId: (value) => {
        return isAutomatedTesting && value
      },
    },
  }
})
